import type { PayloadAction } from "@reduxjs/toolkit"
import { createSlice } from "@reduxjs/toolkit"

import type { CallHistoryItem, RoomHistoryItem } from "@/api/types"
import { logoutAction } from "@/store/session/logoutAction"
import type { RootState } from "@/store/store"

interface HistoryState {
  callHistory: CallHistoryItem[]
  meetingHistory: RoomHistoryItem[]
}

const initialState: HistoryState = {
  callHistory: [],
  meetingHistory: [],
}

const historySlice = createSlice({
  name: "history",
  initialState,
  reducers: {
    setHistory: (state, action: PayloadAction<HistoryState>) => {
      state.callHistory = action.payload.callHistory
      state.meetingHistory = action.payload.meetingHistory
    },
    setCallHistory: (state, action: PayloadAction<CallHistoryItem[]>) => {
      state.callHistory = action.payload
    },
    setRoomHistory: (state, action: PayloadAction<RoomHistoryItem[]>) => {
      state.meetingHistory = action.payload
    },
    removeFromHistory: (
      state,
      action: PayloadAction<RoomHistoryItem["itemId"]>,
    ) => {
      state.meetingHistory = state.meetingHistory.filter(
        (i) => i.itemId !== action.payload,
      )
    },
  },
  extraReducers: (builder) => {
    builder.addCase(logoutAction, () => initialState)
  },
})

export const { setHistory, setCallHistory, setRoomHistory, removeFromHistory } =
  historySlice.actions

export const selectCallHistory = (state: RootState) => state.history.callHistory

export default historySlice.reducer
